import {
  GET_CUSTOMER_MANAGERS,
  LOADING_CUSTOMER_MANAGERS,
  GET_CUSTOMER_MANAGERS_BIS,
  LOADING_CUSTOMER_MANAGERS_BIS
} from "../../../actions/core/administration/customer_manager";

import {
  GET_PROGRAM_MANAGERS,
  LOADING_PROGRAM_MANAGERS
} from "../../../actions/core/administration/program_manager";


export default (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMER_MANAGERS:
      return {
        ...state,
        customerManagers: action.customerManagers,
        loading: false
      };
    case LOADING_CUSTOMER_MANAGERS:
      return{
        ...state,
        loading: true
      };
    case LOADING_CUSTOMER_MANAGERS_BIS:
      return {
        ...state,
        loadingCustomers: true
      };
    case GET_CUSTOMER_MANAGERS_BIS:
      return {
        ...state,
        customerManagersBis: action.customerManagersBis,
        loadingCustomers: false
      };
    case LOADING_PROGRAM_MANAGERS:
      return {
        ...state,
        loadingProgramManagers: true
      };
    case GET_PROGRAM_MANAGERS:
      return {
        ...state,
        programManagers: action.programManagers,
        loadingProgramManagers: false
      };
    default:
      return state;
  }
};
